import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";

import SectionBox from "../../elements/SectionBox/SectionBox";
import ClicksListElement from "./ClicksListElement";
import ClicksCampaignsElement from "./ClicksCampaignsElement";

import {callAPI, log} from "../../utils/utils";

import "./StatisticsPage.scss";

const ClicksBox = () => {
  const { t } = useTranslation();

  const [ clicksData, setClicksData ] = useState(null);
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    callAPI("statistics/clicks", "GET").then((data) => {
      log(data);
      setClicksData(data);
      setLoading(false);
    });
  }, []);

  const campaignClicksHTML = !clicksData ? <></> : clicksData.campaignClicks.map((item, index) => {
    return <ClicksCampaignsElement index={index} key={index} campaign={item} campaigns={clicksData.campaigns} mode={'amount'}/>;
  });

  const clicksListHTML = !clicksData ? <></> : clicksData.clicks.map((item, index) => {
    return <ClicksListElement index={index} key={index} click={item} campaigns={clicksData.campaigns}/>;
  });

  return (
    <SectionBox loading={loading} headline={"ClicksBox.Headline"} info={"ClicksBox.InfoText"} width={1000}>
      {clicksData &&
        <>
          <div className={'clicks-overview__box'}>
          </div>
          <div className={'clicks-campaigns__box'}>
            <div className={'clicks-campaigns__element list-header'}>
              <div>{t('ClicksBox.Column_1_1')}</div>
              <div>{t('ClicksBox.Column_1_2')}</div>
              <div>{t('ClicksBox.Column_1_3')}</div>
              <div>{t('ClicksBox.Column_1_4')}</div>
              <div>{t('ClicksBox.Column_1_5')}</div>
              <div>{t('ClicksBox.Column_1_6')}</div>
              <div>{t('ClicksBox.Column_1_7')}</div>
            </div>
            {campaignClicksHTML}
          </div>
          <div className={'clicks-list__box'}>
            <div className={'clicks-list__element list-header'}>
              <div>{t('ClicksBox.Column_2_1')}</div>
              <div>{t('ClicksBox.Column_2_2')}</div>
              <div>{t('ClicksBox.Column_2_3')}</div>
            </div>
            {clicksListHTML}
          </div>
        </>
      }
    </SectionBox>
  );
}

export default ClicksBox;